import { clickedSocialShareIcon } from './instrumentation';

export const copyHandler = (
  e,
  shareUrl,
  setShowToast,
  productData,
  paramsExist,
) => {
  const btn = e.currentTarget.classList;
  if (setShowToast) setShowToast(true);
  btn.add('lowOpacity');
  setTimeout(() => {
    btn.remove('lowOpacity');
  }, 300);
  setTimeout(() => {
    if (setShowToast) setShowToast(false);
  }, 1500);
  const share_url = generateUrlWithUtm(
    shareUrl,
    'web_copy_url_share',
    paramsExist,
  );
  window?.navigator?.clipboard?.writeText(share_url);

  clickedSocialShareIcon(productData, 'copy_link');
};
export const addClickEffect = (element) => {
  element.classList.add('lowOpacity');
  setTimeout(() => {
    element.classList.remove('lowOpacity');
  }, 300);
};
export const socialShareHandler = (shareRef, productData, ctaText) => {
  addClickEffect(shareRef.current);
  clickedSocialShareIcon(productData, ctaText);
};
// export const facebookHandler = (shareRef, productData) => {
//     addClickEffect(shareRef.current);
//     clicked_facebook_share(productData);
// };
// export const messengerHandler = (shareRef, productData) => {
//     addClickEffect(shareRef.current);
//     clicked_messenger_event(productData);
// };

export const generateUrlWithUtm = (shareUrl, source, paramsExist) => {
  if (paramsExist)
    return `${shareUrl}&utm_source=${source}&utm_campaign=${source}`;
  return `${shareUrl}?utm_source=${source}&utm_campaign=${source}`;
};
